import { j as s } from "../../jsx-runtime-BwWtxLpl.js";
import x, { useMemo as j } from "react";
import o from "classnames";
const q = ({
  className: t = "",
  fullscreen: d = !1,
  children: e = null,
  show: r = !1,
  tip: l = null,
  variant: i = "default",
  size: a = "md",
  ...n
}) => {
  const u = o({
    "motif-progress-loader": !0,
    "motif-progress-loader-fullscreen": d,
    "motif-progress-loading": e && r,
    [t]: !!t
  }), c = o({
    "motif-progress-nested": !0,
    "motif-progress-blur": e && r
  }), f = o({
    "motif-progress-loader-circular": !0,
    [`motif-progress-loader-circular-${a}`]: a
  }), p = j(() => {
    switch (i) {
      case "circular":
        return /* @__PURE__ */ s.jsx("span", { className: f });
      case "linear":
        return /* @__PURE__ */ s.jsx("span", { className: "motif-progress-loader-linear" });
      case "default":
      default:
        return /* @__PURE__ */ s.jsxs("div", { className: "motif-progress-loader-content", children: [
          /* @__PURE__ */ s.jsx("div", { className: "motif-progress-loader-square" }),
          /* @__PURE__ */ s.jsx("div", { className: "motif-progress-loader-square" }),
          /* @__PURE__ */ s.jsx("div", { className: "motif-progress-loader-square" })
        ] });
    }
  }, [i, a]), g = () => {
    const m = /* @__PURE__ */ s.jsxs("div", { className: "motif-progress-loader-type", children: [
      p,
      l && /* @__PURE__ */ s.jsx("div", { children: l })
    ] });
    return r ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      m,
      e && /* @__PURE__ */ s.jsx("div", { className: c, children: e })
    ] }) : e ? /* @__PURE__ */ s.jsx("div", { className: c, children: e }) : m;
  };
  return /* @__PURE__ */ s.jsx(x.Fragment, { children: /* @__PURE__ */ s.jsx("div", { ...n, className: u, "data-motif-progress-loader": !0, children: g() }) });
};
export {
  q as MotifProgressLoader
};
